import styled from '@emotion/styled';
import { DSSearchInput } from '@hundred5/design-system';
import React from 'react';

interface SearchBarProps {
  placeholder: string;
  value: string;
  reset: () => void;
  handleSearchChange: (event: any) => void;
  handleSearchBlur?: () => void;
}

export function SearchBar({
  placeholder,
  value,
  reset,
  handleSearchChange,
  handleSearchBlur,
}: SearchBarProps) {
  return (
    <SearchInputContainer>
      <DSSearchInput
        placeholder={placeholder}
        value={value}
        showResetButton
        reset={reset}
        onChange={handleSearchChange}
        onBlur={handleSearchBlur}
      />
    </SearchInputContainer>
  );
}
const SearchInputContainer = styled.div`
  width: 325px;
  z-index: 10;
`;
